export enum StorageKeys {
    CurrentDocClass = 'CurrentDocClass',
    TenantId = 'TenantId',
    AccessToken = 'access_token',
    ApiBaseUrl = 'ApiBaseUrl',
    Language = 'language',
    RightPanelCollapsed = 'RightPanelCollapsed',
    NavigationCollapsed = 'NavigationCollapsed',
    WidthHeaderFields = 'WidthHeaderFields',
    WidthInvoiceLines = 'WidthInvoiceLines',
    HeightCodingMatching = 'HeightCodingMatching',
    HeightPreviewContent = 'HeightPreviewContent',
    WidthCopyCodingLinesPreview = 'WidthCopyCodingLinesPreview',
    WidthListPreview = 'WidthListPreview',
    ShowListPreview = 'ShowListPreview',
    WidthLinkDocumentsPreview = 'WidthLinkDocumentsPreview',
    ZoomLevelDocumentPage = 'ZoomLevelDocumentPage',
    ZoomLevelDocumentExternalView = 'ZoomLevelDocumentExternalView',
    ZoomLevelPreviewModal = 'ZoomLevelPreviewModal',
    ZoomLevelCopyCodingModal = 'ZoomLevelCopyCodingModal',
    ZoomLevelLinkDocumentsModal = 'ZoomLevelLinkDocumentsModal',
    ZoomLevelListPreview = 'ZoomLevelListPreview',
    ZoomLevelRepairDocumentModal = 'ZoomLevelRepairDocumentModal',
    ZoomLevelEditDocumentModal = 'ZoomLevelEditDocumentModal',
    ZoomLevelFileHandler = 'ZoomLevelFileHandler',
    GridDocList = 'GridDocList',
    GridCoding = 'GridCoding',
    GridTemplateSharingManagement = 'GridTemplateSharingManagement',
    GridLinkDocumentsList = 'GridLinkDocumentsList',
    GridCopyCodingList = 'GridCopyCodingList',
    GridCopyCodingLines = 'GridCopyCodingLines',
    GridMatchingInvoiceLines = 'GridMatchingInvoiceLines',
    GridMatchingOrderLines = 'GridMatchingOrderLines',
    GridExternalInfo = 'GridExternalInfo',
    GridCreditorValidation = 'GridCreditorValidation',
    GridSearch = 'GridSearch',
    GridOcrTrainingLog = 'GridOcrTrainingLog',
    GridDocumentAudit = 'GridDocumentAudit',
    GridLineSourcePreview = 'GridLineSourcePreview',
    GridFileHandlerAdministrations = 'GridFileHandlerAdministrations',
    GridRoutingTable = 'GridRoutingTable',
    SearchValues = 'SearchValues',
    SearchOperators = 'SearchOperators',
    SearchSettings = 'SearchSettings',
    StartPage = 'StartPage',
    FileHandlerStates = 'FileHandlerStates',
    FileHandlerSplitSizes = 'FileHandlerSplitSizes',
    FileHandlerThumbnailWidth = 'FileHandlerThumbnailWidth',
    FileHandlerThumbnailsPerRow = 'FileHandlerThumbnailsPerRow',
    FileHandlerPinnedAdministrations = 'FileHandlerPinnedAdministrations',
    ShowCopyEmailAddress = 'ShowCopyEmailAddress',
    LoggingSettings = 'LoggingSettings',
    Theme = 'Theme',
    SpacingSetting = 'SpacingSetting',
    ReleasesNotificationCounter = 'ReleasesNotificationCounter',
    // Feature flags
    RedPencil = 'RedPencil',
    OcrTraining = 'OcrTraining',
    TemplateSharing = 'TheFeatureFlagWhichShallNotBeNamed',
    TemplateSharingManagement = 'TemplateSharingManagement',
    OcrCodingTrainingFields = 'OcrCodingTrainingFields',
    SamDebug = 'SamDebug',
    HideSamIntroductionModal = 'HideSamIntroductionModal',
    CachedLookups = 'CachedLookups',
    FileHandlerMultipleDocClasses = 'FileHandlerMultipleDocClasses',
    LinkDocuments = 'LinkDocuments',
    TraceShell = 'TraceShell',
    UseStrictDevicePixelRatio = 'UseStrictDevicePixelRatio',
    ReuseTargetWindow = 'ReuseTargetWindow',
    MatomoDataLake = 'MatomoDataLake',
    TestDocumentIndicator = 'TestDocumentIndicator',
    SamBackOfficeStatusHelper = 'SamBackOfficeStatusHelper',
}

export type FeatureFlagStorageKeys =
    | StorageKeys.TraceShell
    | StorageKeys.RedPencil
    | StorageKeys.OcrTraining
    | StorageKeys.OcrCodingTrainingFields
    | StorageKeys.TemplateSharing
    | StorageKeys.TemplateSharingManagement
    | StorageKeys.SamDebug
    | StorageKeys.HideSamIntroductionModal
    | StorageKeys.CachedLookups
    | StorageKeys.FileHandlerMultipleDocClasses
    | StorageKeys.LinkDocuments
    | StorageKeys.UseStrictDevicePixelRatio
    | StorageKeys.MatomoDataLake
    | StorageKeys.TestDocumentIndicator
    | StorageKeys.SamBackOfficeStatusHelper;
